var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import SalesFilter, { EFilterOnChangeAction, } from "@frameworks/salesjourney/components/Generic/SalesFilter";
import filterDi from "../filterDi/serviceLocator";
import React, { useState } from "react";
import { EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import GenericDropdownFilter from "../Generic/GenericDropdownFilter";
import { getFilterDropdownList, } from "@frameworks/salesjourney/components/constant";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { expiryFilters } from "@frameworks/salesjourney/components/Features/LeadDashboard/constant";
var FilterState = function (props) {
    var _a = __read(useState(props.filterList), 2), filterState = _a[0], setFilterState = _a[1];
    var _b = __read(useState(false), 2), loader = _b[0], setLoader = _b[1];
    var allValueObj = {
        title: "All",
        value: "0",
        checked: false,
    };
    // const [displayBubbleFilters, setDisplayBubbleFilters] = useState<
    //   IFilterDataDetailsEntity[]
    // >([]);
    React.useEffect(function () {
        setFilterState(__spreadArray([], __read(props.filterList), false));
    }, [props.filterList]);
    React.useEffect(function () {
        if (props.resetFilter) {
            setFilterState(props.filterList);
        }
    }, [props.resetFilter]);
    React.useEffect(function () {
        getShowDot();
    }, [filterState, props.finalFilterState]);
    var getShowDot = function () {
        setFilterState(function (localFilterState) {
            if (localFilterState && localFilterState.length > 0)
                localFilterState.map(function (record) {
                    var _a, _b, _c, _d, _e, _f;
                    //  let showDot: boolean = false;
                    var localFilterNewState = null;
                    if (record.inputType && record.inputType === "dropdown") {
                        localFilterNewState = null;
                    }
                    else {
                        localFilterNewState = [];
                    }
                    var singleFilter = filterState.findIndex(function (x) { return x.filter === record.filter; });
                    if (record.inputType &&
                        props.finalFilterState[(_a = filterState[singleFilter]) === null || _a === void 0 ? void 0 : _a.value] !== null &&
                        props.finalFilterState[(_b = filterState[singleFilter]) === null || _b === void 0 ? void 0 : _b.value] !== undefined) {
                        if (record.inputType === "dropdown") {
                            localFilterNewState =
                                props.finalFilterState[(_c = filterState[singleFilter]) === null || _c === void 0 ? void 0 : _c.value];
                        }
                        else if (props.finalFilterState[(_d = filterState[singleFilter]) === null || _d === void 0 ? void 0 : _d.value].length > 0) {
                            props.finalFilterState[(_e = filterState[singleFilter]) === null || _e === void 0 ? void 0 : _e.value].map(function (localRecord) {
                                localFilterNewState.push(localRecord === null || localRecord === void 0 ? void 0 : localRecord.toString());
                            });
                        }
                    }
                    if (!!!record.isOnlyCheckbox &&
                        Array.isArray(localFilterNewState) &&
                        localFilterNewState.length > 0) {
                        record.showDot = true;
                    }
                    else if (record.isOnlyCheckbox) {
                        record.showDot = props.finalFilterState[(_f = filterState[singleFilter]) === null || _f === void 0 ? void 0 : _f.value];
                    }
                    else {
                        if (record.inputType === "dropdown" && !!localFilterNewState) {
                            record.showDot = true;
                        }
                        else {
                            record.showDot = false;
                        }
                    }
                    return record;
                });
            return localFilterState;
        });
    };
    var onclick = function (filterName, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        setLoader(true);
        var singleFilter = filterState.findIndex(function (x) { return x.filter === filterName; });
        if (filterState[singleFilter] && filterState[singleFilter].searchBox) {
            filterState[singleFilter].dropDownList = [];
            filterState[singleFilter].searchValue = "";
        }
        var localFilterNewState = null;
        var clearDropDownlist = ["status", "sourceId"];
        if (((_b = (_a = filterState[singleFilter]) === null || _a === void 0 ? void 0 : _a.dropDownList) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
            clearDropDownlist.includes(filterState[singleFilter].value) &&
            props.finalFilterState[(_c = filterState[singleFilter]) === null || _c === void 0 ? void 0 : _c.value] !== null &&
            props.finalFilterState[(_d = filterState[singleFilter]) === null || _d === void 0 ? void 0 : _d.value] !== undefined &&
            props.finalFilterState[(_e = filterState[singleFilter]) === null || _e === void 0 ? void 0 : _e.value].length > 0) {
            filterState[singleFilter].dropDownList = [];
        }
        if (((_g = (_f = filterState[singleFilter]) === null || _f === void 0 ? void 0 : _f.dropDownList) === null || _g === void 0 ? void 0 : _g.length) > 0) {
            if (type === "dropdown") {
                if (props.finalFilterState[filterState[singleFilter].value] !== null &&
                    props.finalFilterState[filterState[singleFilter].value] !== undefined &&
                    props.finalFilterState[filterState[singleFilter].value]) {
                    var findFilterState = (_j = (_h = filterState[singleFilter]) === null || _h === void 0 ? void 0 : _h.dropDownList) === null || _j === void 0 ? void 0 : _j.find(function (record) {
                        return record.value ===
                            props.finalFilterState[filterState[singleFilter].value];
                    });
                    if (findFilterState) {
                        localFilterNewState = findFilterState.value;
                    }
                    else {
                        localFilterNewState = null;
                    }
                }
            }
            else {
                localFilterNewState = [];
                (_l = (_k = filterState[singleFilter]) === null || _k === void 0 ? void 0 : _k.dropDownList) === null || _l === void 0 ? void 0 : _l.map(function (record) {
                    if (record.checked) {
                        localFilterNewState.push(record.value);
                    }
                });
            }
        }
        else {
            if (type === "dropdown") {
                localFilterNewState = null;
            }
            else {
                localFilterNewState = [];
            }
            if (type !== "dropdown" &&
                props.finalFilterState[(_m = filterState[singleFilter]) === null || _m === void 0 ? void 0 : _m.value] !== null &&
                props.finalFilterState[(_o = filterState[singleFilter]) === null || _o === void 0 ? void 0 : _o.value] !== undefined &&
                props.finalFilterState[(_p = filterState[singleFilter]) === null || _p === void 0 ? void 0 : _p.value].length > 0) {
                props.finalFilterState[(_q = filterState[singleFilter]) === null || _q === void 0 ? void 0 : _q.value].map(function (record) {
                    localFilterNewState.push(record.toString());
                });
            }
            else if (type === "dropdown" &&
                props.finalFilterState[(_r = filterState[singleFilter]) === null || _r === void 0 ? void 0 : _r.value] !== null &&
                props.finalFilterState[(_s = filterState[singleFilter]) === null || _s === void 0 ? void 0 : _s.value] !== undefined &&
                props.finalFilterState[(_t = filterState[singleFilter]) === null || _t === void 0 ? void 0 : _t.value] > 0 &&
                (((_u = filterState[singleFilter]) === null || _u === void 0 ? void 0 : _u.value) === "expiryId" ||
                    ((_v = filterState[singleFilter]) === null || _v === void 0 ? void 0 : _v.value) === "followupCount" ||
                    ((_w = filterState[singleFilter]) === null || _w === void 0 ? void 0 : _w.value) === "sourceId" ||
                    ((_x = filterState[singleFilter]) === null || _x === void 0 ? void 0 : _x.value) === "leadType")) {
                localFilterNewState =
                    props.finalFilterState[(_y = filterState[singleFilter]) === null || _y === void 0 ? void 0 : _y.value];
            }
        }
        if (!(((_z = filterState[singleFilter]) === null || _z === void 0 ? void 0 : _z.value) === "followupCount" ||
            ((_0 = filterState[singleFilter]) === null || _0 === void 0 ? void 0 : _0.value) === "leadType")) {
            filterState[singleFilter].dropDownList = [];
        }
        props.setFinalFilterState(function (filState) {
            var _a;
            var _b, _c, _d, _e;
            var list = __assign(__assign({}, filState), (_a = {}, _a[filterState[singleFilter].value] = localFilterNewState, _a.dataSource = (_b = filterState[singleFilter]) === null || _b === void 0 ? void 0 : _b.dataSource, _a));
            var apiPromise = null;
            if (filterState[singleFilter].value === "scheme" ||
                filterState[singleFilter].value === "custType" ||
                filterState[singleFilter].value === "mode" ||
                filterState[singleFilter].value === "status" ||
                filterState[singleFilter].value === "interactionStatus" ||
                filterState[singleFilter].value === "categoryId" ||
                filterState[singleFilter].value === "sourceId" ||
                filterState[singleFilter].value === "subSourceId" ||
                filterState[singleFilter].value === "interactionSubStatus" ||
                filterState[singleFilter].value === "displayId" ||
                (filterState[singleFilter].value === "productId" &&
                    filterState[singleFilter].isExternalApi) ||
                filterState[singleFilter].value === "bucketId" ||
                filterState[singleFilter].value === "categoryId" ||
                filterState[singleFilter].value === EnumSalesFilter.partnerId) {
                if (filterState[singleFilter].value === "displayId" &&
                    props.finalFilterState[filterState[singleFilter].value] !== null &&
                    props.finalFilterState[filterState[singleFilter].value] !== undefined) {
                    apiPromise = props.getFilterDataApis(filterState[singleFilter].value, "", props.finalFilterState[filterState[singleFilter].value]);
                }
                else {
                    apiPromise = props.getFilterDataApis(filterState[singleFilter].value, "", null, null, list);
                }
            }
            else {
                if (filterState[singleFilter].value === "expiryId" ||
                    filterState[singleFilter].value === "followupCount" ||
                    ((_c = filterState[singleFilter]) === null || _c === void 0 ? void 0 : _c.value) === "leadType") {
                    apiPromise === null;
                }
                else {
                    apiPromise = filterDi.filter.getFilterDataActions({
                        filterData: __assign({}, list),
                        page: "0",
                        pageSize: "100",
                    });
                }
            }
            if (apiPromise) {
                apiPromise
                    .then(function (dropDownlist) {
                    if (dropDownlist.filterData && dropDownlist.filterData.length > 0)
                        filterState[singleFilter].dropDownList =
                            dropDownlist.filterData.map(function (x) {
                                if (filterState[singleFilter].defaultSelected === x.name) {
                                    return {
                                        title: x.name,
                                        value: x.id.toString(),
                                        checked: true,
                                    };
                                }
                                else {
                                    return {
                                        title: x.name,
                                        value: x.id.toString(),
                                        checked: type === "dropdown"
                                            ? localFilterNewState &&
                                                localFilterNewState.toString() === x.id.toString()
                                            : (localFilterNewState === null || localFilterNewState === void 0 ? void 0 : localFilterNewState.length) > 0 &&
                                                localFilterNewState.includes(x.id.toString())
                                                ? true
                                                : false,
                                    };
                                }
                            });
                    // if (filterState[singleFilter].inputType !== "dropdown") {
                    //   filterState[singleFilter].dropDownList.splice(0, 0, allValueObj);
                    // }
                    setFilterState(filterState);
                    setLoader(false);
                })
                    .catch(function (err) {
                    console.log(err);
                    setLoader(false);
                });
            }
            else {
                if (filterState[singleFilter].value === "expiryId") {
                    filterState[singleFilter].dropDownList = [
                        {
                            title: "Today",
                            value: "1",
                            checked: localFilterNewState && localFilterNewState.toString() === "1"
                                ? true
                                : false,
                        },
                        {
                            title: "This Week",
                            value: "2",
                            checked: localFilterNewState && localFilterNewState.toString() === "2"
                                ? true
                                : false,
                        },
                        {
                            title: "This Month",
                            value: "3",
                            checked: localFilterNewState && localFilterNewState.toString() === "3"
                                ? true
                                : false,
                        },
                        {
                            title: "Expired",
                            value: "4",
                            checked: localFilterNewState && localFilterNewState.toString() === "4"
                                ? true
                                : false,
                        },
                    ];
                    setFilterState(filterState);
                    setLoader(false);
                }
                else if (filterState[singleFilter].value === "followupCount" ||
                    ((_d = filterState[singleFilter]) === null || _d === void 0 ? void 0 : _d.value) === "leadType") {
                    var localFilterListNew = filterState[singleFilter].dropDownList;
                    if (((_e = filterState[singleFilter].dropDownList) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                    }
                    else {
                        localFilterListNew = getFilterDropdownList(filterState[singleFilter].value);
                    }
                    filterState[singleFilter].dropDownList = localFilterListNew.map(function (x) {
                        return {
                            title: x.title,
                            value: x.value,
                            checked: type === "dropdown"
                                ? localFilterNewState &&
                                    localFilterNewState !== null &&
                                    localFilterNewState !== undefined &&
                                    localFilterNewState.toString() === x.value
                                : (localFilterNewState === null || localFilterNewState === void 0 ? void 0 : localFilterNewState.length) > 0 &&
                                    localFilterNewState.includes(x.id.toString())
                                    ? true
                                    : false,
                        };
                    });
                    setFilterState(filterState);
                    setLoader(false);
                }
                else {
                    filterState[singleFilter].dropDownList = [];
                    setFilterState(filterState);
                    setLoader(false);
                }
            }
            return list;
        });
    };
    var getBooleanFilterState = function (filterName, type) {
        var _a, _b, _c, _d;
        var singleFilter = filterState.findIndex(function (x) { return x.filter === filterName; });
        if (type === "checkbox" &&
            props.finalFilterState[(_a = filterState[singleFilter]) === null || _a === void 0 ? void 0 : _a.value] !== null &&
            props.finalFilterState[(_b = filterState[singleFilter]) === null || _b === void 0 ? void 0 : _b.value] !== undefined &&
            props.finalFilterState[(_c = filterState[singleFilter]) === null || _c === void 0 ? void 0 : _c.value]) {
            return props.finalFilterState[(_d = filterState[singleFilter]) === null || _d === void 0 ? void 0 : _d.value];
        }
        else
            return false;
    };
    var updateBooleanFilter = function (filterName, type, isChecked) {
        var _a, _b, _c, _d;
        var singleFilter = filterState.findIndex(function (x) { return x.filter === filterName; });
        var localAllFilters = __spreadArray([], __read(filterState), false);
        var LocalFilterState = props.finalFilterState;
        if (type === "checkbox" &&
            LocalFilterState[(_a = filterState[singleFilter]) === null || _a === void 0 ? void 0 : _a.value] !==
                null &&
            LocalFilterState[(_b = filterState[singleFilter]) === null || _b === void 0 ? void 0 : _b.value] !==
                undefined) {
            LocalFilterState[(_c = filterState[singleFilter]) === null || _c === void 0 ? void 0 : _c.value] = isChecked;
            // (LocalFilterState[
            //   filterState[singleFilter]?.value as EnumSalesFilter
            // ] as boolean) = !(LocalFilterState[
            //   filterState[singleFilter]?.value as EnumSalesFilter
            // ] as boolean);
            // localAllFilters[singleFilter].showDot = LocalFilterState[
            //   filterState[singleFilter]?.value as EnumSalesFilter
            // ] as boolean;
        }
        else {
            LocalFilterState[(_d = filterState[singleFilter]) === null || _d === void 0 ? void 0 : _d.value] = isChecked;
            // (LocalFilterState[
            //   filterState[singleFilter]?.value as EnumSalesFilter
            // ] as boolean) = false;
        }
        localAllFilters[singleFilter].showDot = isChecked;
        props.setFinalFilterState(LocalFilterState);
        setFilterState(localAllFilters);
    };
    var clearDropDownFilters = function (filterName) {
        var lstobj = filterName + "Lst";
        var _a = props === null || props === void 0 ? void 0 : props.finalFilterState, _b = filterName, _ = _a[_b], _c = lstobj, __ = _a[_c], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + "", typeof _c === "symbol" ? _c : _c + ""]);
        var obj = rest;
        if (filterName === EnumSalesFilter.expiryId) {
            obj === null || obj === void 0 ? true : delete obj.ExpiryfromDate;
            obj === null || obj === void 0 ? true : delete obj.ExpirytoDate;
        }
        // filterDI.filter.updateFinalFilterState(obj);
        props === null || props === void 0 ? void 0 : props.setFinalFilterState(obj);
        // props?.onSubmit();
        // props?.setDisplayBubbleFilters((prevState: IFilterDataDetailsEntity[]) => {
        //   let tempArr = [];
        //   tempArr = prevState.filter((item) => item.parentFilter !== filterName);
        //   if (tempArr.length === 0) {
        //     props.applyFiltersAfterRemovingExpiryFilter();
        //   }
        //   return tempArr;
        // });
    };
    var changeSearchValue = function (filterName, searchText, type) { return __awaiter(void 0, void 0, void 0, function () {
        var singleFilter, localFilterNewState, apiPromise;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            singleFilter = filterState.findIndex(function (x) { return x.filter === filterName; });
            filterState[singleFilter].searchValue = searchText;
            filterState[singleFilter].dropDownList = [];
            setFilterState(filterState);
            setLoader(true);
            localFilterNewState = null;
            if (type === "dropdown") {
                localFilterNewState = null;
            }
            else {
                localFilterNewState = [];
            }
            if (type !== "dropdown" &&
                props.finalFilterState[(_a = filterState[singleFilter]) === null || _a === void 0 ? void 0 : _a.value] !== null &&
                props.finalFilterState[(_b = filterState[singleFilter]) === null || _b === void 0 ? void 0 : _b.value] !== undefined &&
                props.finalFilterState[(_c = filterState[singleFilter]) === null || _c === void 0 ? void 0 : _c.value].length > 0) {
                props.finalFilterState[(_d = filterState[singleFilter]) === null || _d === void 0 ? void 0 : _d.value].map(function (record) {
                    localFilterNewState.push(record.toString());
                });
            }
            else if (type === "dropdown" &&
                props.finalFilterState[(_e = filterState[singleFilter]) === null || _e === void 0 ? void 0 : _e.value] !== null &&
                props.finalFilterState[(_f = filterState[singleFilter]) === null || _f === void 0 ? void 0 : _f.value] !== undefined &&
                props.finalFilterState[(_g = filterState[singleFilter]) === null || _g === void 0 ? void 0 : _g.value] > 0 &&
                ((_h = filterState[singleFilter]) === null || _h === void 0 ? void 0 : _h.value) === "type") {
                localFilterNewState =
                    props.finalFilterState[(_j = filterState[singleFilter]) === null || _j === void 0 ? void 0 : _j.value];
            }
            apiPromise = null;
            if (filterState[singleFilter].value === "displayId" ||
                filterState[singleFilter].value === "productId" ||
                filterState[singleFilter].value === "categoryId" ||
                filterState[singleFilter].value === EnumSalesFilter.partnerId) {
                if (filterState[singleFilter].value === "displayId" &&
                    props.finalFilterState[filterState[singleFilter].value] !== null &&
                    props.finalFilterState[filterState[singleFilter].value] !== undefined) {
                    apiPromise = props.getFilterDataApis(filterState[singleFilter].value, searchText, props.finalFilterState[filterState[singleFilter].value]);
                }
                else {
                    apiPromise = props.getFilterDataApis(filterState[singleFilter].value, searchText, null, null, props.finalFilterState);
                }
            }
            else {
                apiPromise = filterDi.filter.getFilterDataActions({
                    filterData: props.finalFilterState,
                    page: "0",
                    pageSize: "100",
                    searchText: searchText,
                });
            }
            if (apiPromise) {
                apiPromise
                    .then(function (dropDownlist) {
                    var _a;
                    if (dropDownlist && ((_a = dropDownlist.filterData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        filterState[singleFilter].dropDownList =
                            dropDownlist.filterData.map(function (x) {
                                return {
                                    title: x.name,
                                    value: x.id.toString(),
                                    checked: type === "dropdown"
                                        ? localFilterNewState &&
                                            localFilterNewState.toString() === x.id.toString()
                                        : (localFilterNewState === null || localFilterNewState === void 0 ? void 0 : localFilterNewState.length) > 0 &&
                                            localFilterNewState.includes(x.id.toString())
                                            ? true
                                            : false,
                                };
                            });
                    }
                    setFilterState(filterState);
                    setLoader(false);
                })
                    .catch(function (err) {
                    console.log(err);
                    setLoader(false);
                });
            }
            else {
                filterState[singleFilter].dropDownList = [];
                setFilterState(filterState);
                setLoader(false);
            }
            return [2 /*return*/];
        });
    }); };
    var onChange = function (filterName, id, type, checked, newFilterName, actionFrom) {
        var _a, _b, _c, _d, _e, _f, _g;
        // console.log("hiii", filterName, id, newFilterName, checked);
        var finalfilterNewState = __assign({}, props.finalFilterState);
        var filterLocalNewState = __spreadArray([], __read(filterState), false);
        var filterUIIndex = filterLocalNewState.findIndex(function (x) { return x.value === filterName; });
        if (type === "checkbox") {
            filterLocalNewState[filterUIIndex].dropDownList = filterLocalNewState[filterUIIndex].dropDownList.map(function (z, index, arr) {
                if (id.toString() === z.value &&
                    filterName === EnumSalesFilter.teamType &&
                    leadStatusConfig.hierarchyTypeObject.id.toString() ===
                        id.toString() &&
                    leadStatusConfig.hierarchyTypeObject.id.toString() === z.value) {
                    var idx = arr.findIndex(function (item) {
                        return (item === null || item === void 0 ? void 0 : item.value) === leadStatusConfig.teamTypeObject.id.toString();
                    });
                    if (idx !== -1 && checked) {
                        arr[idx].checked = true;
                    }
                    return __assign(__assign({}, z), { checked: checked });
                }
                else if (id.toString() === z.value &&
                    filterName === EnumSalesFilter.teamType &&
                    leadStatusConfig.teamTypeObject.id.toString() === id.toString() &&
                    leadStatusConfig.teamTypeObject.id.toString() === z.value) {
                    var idx = arr.findIndex(function (item) {
                        return (item === null || item === void 0 ? void 0 : item.value) === leadStatusConfig.hierarchyTypeObject.id.toString();
                    });
                    if (idx !== -1 && !checked) {
                        arr[idx].checked = false;
                    }
                    return __assign(__assign({}, z), { checked: checked });
                }
                else if (id.toString() === z.value) {
                    return __assign(__assign({}, z), { checked: checked });
                }
                else
                    return z;
            });
            var index = finalfilterNewState[filterName] == null ||
                finalfilterNewState[filterName] == undefined
                ? -1
                : typeof finalfilterNewState[filterName] === "object"
                    ? finalfilterNewState[filterName].findIndex(function (x) { return (x === null || x === void 0 ? void 0 : x.toString()) === (id === null || id === void 0 ? void 0 : id.toString()); })
                    : -1;
            if (index === -1 && checked) {
                if (finalfilterNewState[filterName] === null) {
                    finalfilterNewState[filterName] = [];
                }
                // if (id.toString() === "0") {
                //   filterLocalNewState[filterUIIndex].dropDownList.map((record) => {
                //     if (record.value !== "0" && record.checked)
                //       (finalfilterNewState[filterName] as Array<string | number>).push(
                //         record.value
                //       );
                //   });
                // } else
                if (newFilterName === EnumSalesFilter.teamTypeLst &&
                    leadStatusConfig.hierarchyTypeObject.id.toString() === id.toString()) {
                    var temp = new Set(__spreadArray(__spreadArray([], __read(finalfilterNewState[filterName]), false), [
                        leadStatusConfig.teamTypeObject.id.toString(),
                        leadStatusConfig.hierarchyTypeObject.id.toString(),
                    ], false));
                    finalfilterNewState[filterName] =
                        Array.from(temp);
                }
                else {
                    finalfilterNewState[filterName].push(id);
                }
                var filterObj = filterLocalNewState[filterUIIndex].dropDownList.find(function (localFilter) { return localFilter.value === id.toString(); });
                if (finalfilterNewState[newFilterName] === null ||
                    finalfilterNewState[newFilterName] === undefined) {
                    finalfilterNewState[newFilterName] = [];
                }
                if (newFilterName) {
                    if (newFilterName === EnumSalesFilter.teamTypeLst &&
                        leadStatusConfig.hierarchyTypeObject.id.toString() === id.toString()) {
                        var tempTypeIdx = finalfilterNewState[newFilterName].findIndex(function (item) {
                            return item.id.toString() ===
                                leadStatusConfig.teamTypeObject.id.toString();
                        });
                        finalfilterNewState[newFilterName] = __spreadArray(__spreadArray(__spreadArray([], __read(finalfilterNewState[newFilterName]), false), __read((tempTypeIdx === -1 && [
                            {
                                id: leadStatusConfig.teamTypeObject.id,
                                name: leadStatusConfig.teamTypeObject.name,
                                parentFilter: filterName,
                                inputType: type,
                                checked: checked,
                                filterKey: newFilterName,
                            },
                        ])), false), [
                            {
                                id: leadStatusConfig.hierarchyTypeObject.id,
                                name: leadStatusConfig.hierarchyTypeObject.name,
                                parentFilter: filterName,
                                inputType: type,
                                checked: checked,
                                filterKey: newFilterName,
                            },
                        ], false);
                    }
                    else {
                        finalfilterNewState[newFilterName].push({
                            id: id,
                            name: filterObj.title,
                            parentFilter: filterName,
                            inputType: type,
                            checked: checked,
                            filterKey: newFilterName,
                        });
                    }
                }
            }
            if (index > -1 && !checked) {
                if (filterName === EnumSalesFilter.teamType) {
                    if (leadStatusConfig.teamTypeObject.id.toString() === id.toString()) {
                        // The below code removed value from the filter array or objects which carry the exact values.
                        if (((_a = finalfilterNewState[filterName]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            finalfilterNewState[filterName].splice(index, 1);
                            var idx = finalfilterNewState[filterName].findIndex(function (item) {
                                return item === leadStatusConfig.hierarchyTypeObject.id.toString();
                            });
                            idx !== -1 &&
                                finalfilterNewState[filterName].splice(idx, 1);
                        }
                        // The below code removed value from the LST Array
                        if (((_b = finalfilterNewState[newFilterName]) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            finalfilterNewState[newFilterName].splice(index, 1);
                            var idx = finalfilterNewState[newFilterName].findIndex(function (item) {
                                return item.id.toString() ===
                                    leadStatusConfig.hierarchyTypeObject.id.toString();
                            });
                            idx !== -1 &&
                                finalfilterNewState[newFilterName].splice(idx, 1);
                        }
                    }
                    else {
                        // The below code removed value from the filter array or objects which carry the exact values.
                        if (((_c = finalfilterNewState[filterName]) === null || _c === void 0 ? void 0 : _c.length) > 0)
                            finalfilterNewState[filterName].splice(index, 1);
                        // The below code removed value from the LST Array
                        if (((_d = finalfilterNewState[newFilterName]) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                            finalfilterNewState[newFilterName].splice(index, 1);
                        }
                    }
                    ((_e = filterLocalNewState[filterUIIndex]) === null || _e === void 0 ? void 0 : _e.callAPIInsideOnChange) &&
                        actionFrom === EFilterOnChangeAction.FROM_BUBBLES &&
                        (props === null || props === void 0 ? void 0 : props.onSubmit(finalfilterNewState));
                }
                else {
                    // The below code removed value from the filter array or objects which carry the exact values.
                    if (((_f = finalfilterNewState[filterName]) === null || _f === void 0 ? void 0 : _f.length) > 0)
                        finalfilterNewState[filterName].splice(index, 1);
                    // The below code removed value from the LST Array
                    if (((_g = finalfilterNewState[newFilterName]) === null || _g === void 0 ? void 0 : _g.length) > 0) {
                        finalfilterNewState[newFilterName].splice(index, 1);
                    }
                }
            }
        }
        else if (type === "dropdown") {
            if (filterLocalNewState[filterUIIndex].value === "expiryId") {
                finalfilterNewState[filterName] = id;
                finalfilterNewState.expiryIdLst = [expiryFilters[id]];
                filterLocalNewState[filterUIIndex].dropDownList = [
                    {
                        title: "Today",
                        value: "1",
                        checked: id && id.toString() === "1" ? true : false,
                    },
                    {
                        title: "This Week",
                        value: "2",
                        checked: id && id.toString() === "2" ? true : false,
                    },
                    {
                        title: "This Month",
                        value: "3",
                        checked: id && id.toString() === "3" ? true : false,
                    },
                    {
                        title: "Expired",
                        value: "4",
                        checked: id && id.toString() === "4" ? true : false,
                    },
                ];
                if (!!finalfilterNewState[filterName]) {
                    filterLocalNewState[filterUIIndex].showDot = true;
                }
                else {
                    filterLocalNewState[filterUIIndex].showDot = false;
                }
                setFilterState(filterLocalNewState);
            }
            else if (filterLocalNewState[filterUIIndex].value === "followupCount") {
                finalfilterNewState[filterName] = id;
                filterLocalNewState[filterUIIndex].dropDownList = filterLocalNewState[filterUIIndex].dropDownList.map(function (x) {
                    return {
                        title: x.title,
                        value: x.value,
                        checked: type === "dropdown"
                            ? x.value === id.toString()
                            : true
                                ? true
                                : false,
                    };
                });
                setFilterState(filterLocalNewState);
            }
            else {
                finalfilterNewState[filterName] = [id];
                filterLocalNewState[filterUIIndex].dropDownList = filterLocalNewState[filterUIIndex].dropDownList.map(function (x) {
                    return {
                        title: x.title,
                        value: x.value,
                        checked: id && id.toString() === x.value ? true : false,
                    };
                });
                if (!!finalfilterNewState[filterName] &&
                    finalfilterNewState[filterName].length > 0) {
                    filterLocalNewState[filterUIIndex].showDot = true;
                }
                else {
                    filterLocalNewState[filterUIIndex].showDot = false;
                }
                setFilterState(filterState);
            }
        }
        setFilterState(function (filterLocalNewState) {
            if (filterLocalNewState && filterLocalNewState.length > 0) {
                filterLocalNewState.map(function (record) {
                    var localFilterNewState = null;
                    // if (record.inputType && record.inputType === "dropdown") {
                    //   localFilterNewState = null;
                    // } else {
                    // }
                    localFilterNewState = [];
                    if (record.dropDownList && record.dropDownList.length > 0) {
                        record.dropDownList.map(function (subRecord) {
                            if (subRecord.checked) {
                                if (Array.isArray(localFilterNewState)) {
                                    localFilterNewState.push(subRecord);
                                }
                            }
                        });
                        if (Array.isArray(localFilterNewState) &&
                            localFilterNewState.length > 0) {
                            record.showDot = true;
                        }
                        else {
                            record.showDot = false;
                        }
                    }
                });
            }
            return filterLocalNewState;
        });
        props.setFinalFilterState(finalfilterNewState);
    };
    return (React.createElement(React.Fragment, null, props.isShowGenericDropdownFilter ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pos-rel" },
            React.createElement(GenericDropdownFilter, null)))) : (React.createElement(React.Fragment, null,
        React.createElement(SalesFilter, { isSearch: props.isSearch, 
            // onSearch={{ placeholderClassName: "" }}
            filterList: filterState, onClick: onclick, loader: loader, onCheck: onChange, onSubmit: props.onSubmit, onSearch: (props === null || props === void 0 ? void 0 : props.onSearch) ? props.onSearch : function () { }, changeSearchValue: changeSearchValue, showReset: props.showReset, resetFunction: props.resetFunction, onSearchIconClick: props.onSearchIconClick, mainSearchValue: props === null || props === void 0 ? void 0 : props.mainSearchValue, isShowNewDesign: props === null || props === void 0 ? void 0 : props.isShowNewDesign, finalFilterState: props.finalFilterState, displayBubbleFilters: props === null || props === void 0 ? void 0 : props.displayBubbleFilters, setDisplayBubbleFilters: props === null || props === void 0 ? void 0 : props.setDisplayBubbleFilters, getBooleanFilterState: getBooleanFilterState, updateBooleanFilter: updateBooleanFilter, clearDropDownFilters: clearDropDownFilters, isShowFilterSidebar: props === null || props === void 0 ? void 0 : props.isShowFilterSidebar, setIsShowFilterSidebar: props === null || props === void 0 ? void 0 : props.setIsShowFilterSidebar, parentSearchText: props === null || props === void 0 ? void 0 : props.parentSearchText, propsSearchText: props === null || props === void 0 ? void 0 : props.propsSearchText, updateLeadDashboardURL: props === null || props === void 0 ? void 0 : props.updateLeadDashboardURL })))));
};
export default FilterState;
